var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarFilledIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m2.913 11 .812-3.512L1 5.124l3.6-.312L6 1.5l1.4 3.313 3.6.312-2.725 2.363L9.088 11 6 9.138z"
})));
export { SvgStarFilledIcon as ReactComponent };
export default __webpack_public_path__ + "d56ae79a20e591afff11e4d2775eae90.svg";